export default {
  empty: {
    id: 'purchasesList.empty.title',
    defaultMessage: `You have no ongoing orders.`,
  },
};
